import ActiveMessageMatch from '../models/ActiveMessageMatch';

export async function fetchActiveMessageMatch(
  id: string,
  url: string,
  vin: string,
  locale: string
): Promise<ActiveMessageMatch | null> {
  const response = await fetch(
    `api/webchat/${id}/active-messages/match?url=${window.encodeURIComponent(url)}&locale=${locale}${vin ? '&vin=' + vin : ''}`
  );
  if (!response.ok) {
    throw Error(response.statusText);
  }
  return response.json();
}
